import React from 'react'
import { IconProps } from '../../../common/types'

const TimesheetIcon: React.FC<IconProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 8.688v5M12 22.688c-4.83 0-8.75-3.92-8.75-8.75s3.92-8.75 8.75-8.75 8.75 3.92 8.75 8.75M9 2.688h6"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M14.9 18.027c0-1.43 1.02-2.02 2.26-1.3l1 .58 1 .58c1.24.72 1.24 1.89 0 2.61l-1 .58-1 .58c-1.24.72-2.26.13-2.26-1.3v-2.33"
      ></path>
    </svg>
  )
}

export default TimesheetIcon
